import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
    Button,
    Grid,
    Modal,
    Image,
    Header,
} from 'semantic-ui-react';

import { translate } from "react-translate";
import Exit from '../../../assets/svg/Exit.svg';

const mapStateToProps = state => ({
    app: state.app
})

class ConnectedModalTooMuchLists extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { t } = this.props
        return (
            <Modal size='tiny' open={this.props.isOpen} onClose={this.props.close} >
                <Modal.Header id="modalHeader">
                    <Grid>
                        <Grid.Row>
                            <Grid.Column textAlign='center'>
                                <Image
                                  onClick={this.props.close}
                                  src={Exit}
                                  floated='right'
                                  id="modalExit" />
                                  <Header
                                    id="modalTitle"
                                    as='h2'
                                    textAlign='center'>
                                    {t('info')}
                                  </Header>

                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Header>

                <Modal.Content >
                    <Grid textAlign='center'>
                        <Grid.Row columns={1} id="modalContentText">
                            <p>{t('max_list') + ' '}
                              {' ' + t('extension_page')}.
                              {' ' + t('conseil')}
                            </p>
                        </Grid.Row>
                        <Grid.Row columns={3}>
                            <Grid.Column width={4}></Grid.Column>
                            <Grid.Column width={8}>
                                <Button
                                  id="validBtn"
                                  size='massive'
                                  fluid>
                                  <a href={'#/subs'} style={{color: '#fff'}}>{' ' + t('extension_page')} </a>
                                </Button>
                            </Grid.Column>
                            <Grid.Column width={4}></Grid.Column>
                        </Grid.Row>

                    </Grid>
                </Modal.Content>
            </Modal>
        )
    }
}

const ModalTooMuchLists = connect(mapStateToProps)(ConnectedModalTooMuchLists);
export default translate("ModalTooMuchLists")(ModalTooMuchLists);



// WEBPACK FOOTER //
// ./src/components/Protected/Listes/ModalTooMuchLists.js